import layoutAdmin from '@/layouts/layoutAdmin.vue';

//setttins
import assetscategoriesSetup from '@/views/module/assets/settingsManagement/assetsCategoriesSetup.vue';
import assetsDepreciationList from '@/views/module/assets/settingsManagement/assetsDepreciationList.vue';
import assetsLocationsSetup from '@/views/module/assets/settingsManagement/assetsLocationsSetup.vue';
import assetsStatusTypesSetup from '@/views/module/assets/settingsManagement/assetsStatusTypesSetup.vue';

//Asset Registration
import newAssetRegistrationSetup from '@/views/module/assets/assetRegistrationManagement/newAssetRegistrationSetup.vue';
import assetRegistranRecords from '@/views/module/assets/assetRegistrationManagement/assetRegistranRecords.vue';

//Asset Depreciation
import runDepreciation from '@/views/module/assets/assetDepreciation/runDepreciation.vue';
import depreciationRecords from '@/views/module/assets/assetDepreciation/depreciationRecords.vue';
import assetsMappingSetup from '@/views/module/assets/settingsManagement/assetsAccountsMappingSetup.vue';
import assetRegistrationRecordDetails from '@/views/module/assets/assetRegistrationManagement/assetRegistrationRecordDetails.vue';

//Asset Transfer
import assetTransferList from '@/views/module/assets/assetTransferManagement/assetTransferList.vue';
import assetTransfer from '@/views/module/assets/assetTransferManagement/assetTransfer.vue';
import assetTransferRecordDetails from '@/views/module/assets/assetTransferManagement/assetTransferRecordDetails.vue';

//Asset Maintenance
import assetMaintenanceList from '@/views/module/assets/assetMaintenanceManagement/assetMaintenanceList.vue';
import assetMaintenance from '@/views/module/assets/assetMaintenanceManagement/assetMaintenance.vue';
import assetMaintenanceRecordDetails from '@/views/module/assets/assetMaintenanceManagement/assetMaintenanceRecordDetails.vue';

//Asset Preparation
import assetPreparationList from '@/views/module/assets/assetPreparationManagement/assetPreparationList.vue';
import assetPreparation from '@/views/module/assets/assetPreparationManagement/assetPreparation.vue';
import assetPreparationRecordDetails from '@/views/module/assets/assetPreparationManagement/assetPreparationRecordDetails.vue';

//Asset Disposal
import assetDisposalList from '@/views/module/assets/assetDisposalManagement/assetDisposalList.vue';
import assetDisposal from '@/views/module/assets/assetDisposalManagement/assetDisposal.vue';
import assetDisposalRecordDetails from '@/views/module/assets/assetDisposalManagement/assetDisposalRecordDetails.vue';
import depreciationRecordDetails from '@/views/module/assets/assetDepreciation/depreciationRecordDetails.vue';

//Asset Acquisition (Purchase Received)
import assetAcquisitionRecords from '@/views/module/assets/assetAcquisitionManagement/assetAcquisitionRecords.vue';
import assetAcquisitionReceived from '@/views/module/assets/assetAcquisitionManagement/assetAcquisitionReceived.vue';

export default 
[
    {
        path: '/asset',
        component: layoutAdmin,
        meta: {
            UserLoggedIn: true,
            breadcrumb: 'Asset Management',
        },
        children: [

            //settings

            {
                path: "category-records",
                name: "category-records",
                meta: {
                    breadcrumb: ['Category Records']
                },
                component: assetscategoriesSetup,
            },
            {
                path: "depreciation-methods-records",
                name: "depreciation-methods-records",
                meta: {
                    breadcrumb: ['Depreciation Methods Records']
                },
                component: assetsDepreciationList,
            },
            {
                path: "status-type-records",
                name: "status-type-records",
                meta: {
                    breadcrumb: ['Status Type Records']
                },
                component: assetsStatusTypesSetup,
            },
            {
                path: "location-records",
                name: "location-records",
                meta: {
                    breadcrumb: ['Location Records']
                },
                component: assetsLocationsSetup,
            },
            {
                path: "account-mapping-records",
                name: "account-mapping-records",
                meta: {
                    breadcrumb: ['Account Mapping Records']
                },
                component: assetsMappingSetup,
            },
            
            //Asset Registration

            {
                path: "asset-registration",
                name: "asset-registration",
                meta: {
                    breadcrumb: ['Asset Registration Setup']
                },
                component: newAssetRegistrationSetup,
            },
            {
                path: "asset-records",
                name: "asset-records",
                meta: {
                    breadcrumb: ['Asset Registration Records']
                },
                component: assetRegistranRecords,
            },
            {
                path: "asset-record-details/:id",
                name: "asset-record-details",
                meta: {
                    breadcrumb: ['Asset Registration Details']
                },
                component: assetRegistrationRecordDetails,
            },
            
            //Asset Depreciation

            {
                path: "run-depreciation",
                name: "run-depreciation",
                meta: {
                    breadcrumb: ['Asset Depreciation Records']
                },
                component: runDepreciation,
            },
            {
                path: "depreciation-records",
                name: "depreciation-records",
                meta: {
                    breadcrumb: ['Asset Depreciation Records']
                },
                component: depreciationRecords,
            },
            {
                path: "depreciation-record-details/:id",
                name: "depreciation-record-details",
                meta: {
                    breadcrumb: ['Asset Depreciaton Details']
                },
                component: depreciationRecordDetails,
            },
            
            //Asset Preparation
            
            {
                path: "preparation-records",
                name: "preparation-records",
                meta: {
                    breadcrumb: ['Asset Preparation Records']
                },
                component: assetPreparationList,
            },
            {
                path: "preparation-record-details/:id",
                name: "preparation-record-details",
                meta: {
                    breadcrumb: ['Asset Preparation Details']
                },
                component: assetPreparationRecordDetails,
            },
            {
                path: "add-preparation",
                name: "add-preparation",
                meta: {
                    breadcrumb: ['Add Asset Preparation']
                },
                component: assetPreparation,
            },
            
            //Asset Transfer
            
            {
                path: "transfer-records",
                name: "transfer-records",
                meta: {
                    breadcrumb: ['Asset Transfer Records']
                },
                component: assetTransferList,
            },
            {
                path: "transfer-record-details/:id",
                name: "transfer-record-details",
                meta: {
                    breadcrumb: ['Asset Transfer Details']
                },
                component: assetTransferRecordDetails,
            },
            {
                path: "transfer-setup",
                name: "transfer-setup",
                meta: {
                    breadcrumb: ['Asset Transfer Setup']
                },
                component: assetTransfer,
            },
            
            //Asset Maintenance
            
            {
                path: "maintenance-records",
                name: "maintenance-records",
                meta: {
                    breadcrumb: ['Asset Maintenance Records']
                },
                component: assetMaintenanceList,
            },
            {
                path: "maintenance-record-details/:id",
                name: "maintenance-record-details",
                meta: {
                    breadcrumb: ['Asset Maintenance Details']
                },
                component: assetMaintenanceRecordDetails,
            },
            {
                path: "add-maintenance",
                name: "add-maintenance",
                meta: {
                    breadcrumb: ['Asset Maintenance Setup']
                },
                component: assetMaintenance,
            },
            
            //Asset Disposal
            
            {
                path: "disposal-write-off-records",
                name: "disposal-write-off-records",
                meta: {
                    breadcrumb: ['Asset Disposal/Write-off Records']
                },
                component: assetDisposalList,
            },
            {
                path: "disposal-write-off-record-details/:id",
                name: "disposal-write-off-record-details",
                meta: {
                    breadcrumb: ['Asset Disposal/Write-off Details']
                },
                component: assetDisposalRecordDetails,
            },
            {
                path: "add-disposal-write-off",
                name: "add-disposal-write-off",
                meta: {
                    breadcrumb: ['Add Disposal/Write-off']
                },
                component: assetDisposal,
            },
            
            //Asset Acquisition (Purchase Received)
            
            {
                path: "acquisition-purchase-records",
                name: "acquisition-purchase-records",
                meta: {
                    breadcrumb: ['Asset Acquisition / Purchase Records']
                },
                component: assetAcquisitionRecords,
            },
            {
                path: "add-acquisition-purchase-received",
                name: "add-acquisition-purchase-received",
                meta: {
                    breadcrumb: ['Add Asset Acquisition / Purchase']
                },
                component: assetAcquisitionReceived,
            },
            
        ],

    },
    
]